import Vue from "vue";
import VueRouter from "vue-router";

import DashboardLayout from "@/pages/Layout/DashboardLayout.vue";
import Dashboard from "@/pages/Dashboard.vue";

import AuthLayout from "@/pages/Pages/AuthLayout.vue";

// Pages
import Login from "@/pages/Pages/Login.vue";

import {ifAuthenticated, ifNotAuthenticated} from "./access";

import smsMenu from "./modules/sms"
import pushMenu from "./modules/push";
import callMenu from "./modules/call";
import emailMenu from "./modules/email";
import viberMenu from "./modules/viber";
import whatsappMenu from "./modules/whatsapp";
import mailNotifyMenu from "./modules/mail-notify";
import {redirectMailNotify} from "./modules/mail-notify";
import customMenu from "./modules/custom";
import settingsMenu from "@/routes/modules/settings";
import userManagementMenu from "@/routes/modules/user-management";

import ChangePassword from "@/pages/Pages/ChangePassword.vue";
import financesMenu from "@/routes/modules/finances";
import {ActionLog} from "@/store/auth/types";
import {AccessDenied} from "wings-ui-components";
import store from "@/store";

Vue.use(VueRouter);

const authPages = {
    path: "/",
    component: AuthLayout,
    name: "Authentication",
    beforeEnter: ifNotAuthenticated,
    children: [
        {
            path: "/login",
            name: "Login",
            component: Login
        }
    ]
};

const changePassPages = {
    path: "/",
    component: AuthLayout,
    name: "ChangePasswordLayout",
    beforeEnter: ifAuthenticated,
    children: [
        {
            path: "/change_password",
            name: "ChangePassword",
            component: ChangePassword
        }
    ]
};

const routes = [
    {
        path: "/",
        beforeEnter: ifAuthenticated,
        // redirect: "/user_management/system_users",
        redirect: "/dashboard",
        name: "Home"
    },
    smsMenu,
    pushMenu,
    callMenu,
    emailMenu,
    viberMenu,
    whatsappMenu,
    mailNotifyMenu,
    redirectMailNotify,
    customMenu,
    settingsMenu,
    userManagementMenu,
    financesMenu,
    authPages,
    changePassPages,
    {
        path: "/",
        component: DashboardLayout,
        beforeEnter: ifAuthenticated,
        children: [
            {
                path: "dashboard",
                name: "Dashboard",
                components: {default: Dashboard},
                meta: {
                    icon: "dashboard",
                    msgKey: 'menu.item.main'
                }
            },
        ],
    }, {
        name: "AccessDenied",
        path: "/access_denied",
        component: AccessDenied,
    },
];

const router = new VueRouter({
    base: process.env.BASE_URL,
    mode: "history",
    routes,
    scrollBehavior: to => {
        if (to.hash) {
            return {selector: to.hash};
        } else {
            return {x: 0, y: 0};
        }
    },
    linkExactActiveClass: "nav-item active"
});

router.beforeEach((to, from, next) => {
    const localStorageUserToken = localStorage.getItem("user-token");
    const isLogSystems: string = localStorage.getItem("isLogSystems") || 'false';

    const actionLog: ActionLog = {
        action_page: to.meta.msgKey,
        action: 'Viewing',
        action_status: 'success',
        object_type: 'Page',
    }

    // isLogSystems - она определяет будет ли пользователь логироваться (isLogSystems записывается в localStore при запросе actionGetSystemUsersAction на странице Login.vue)
    // localStorageUserToken - проверяет активен ли токен чтобы избежать логировать страницу входа
    // !to.meta.parentPath - условия чтобы не логировать child страницы (/:id, /new)
    // !from.meta.parentPath - условия чтобы не логировать переход от child к parent (пока не нашел лучшее решение)

    if (JSON.parse(isLogSystems) && Boolean(localStorageUserToken) && !to.meta.parentPath && !from.meta.parentPath && !!from.name) {
        store.dispatch('actionLog', actionLog).catch(e => console.error(e));
    }
    next();
});

export default router;
